
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import {extend, proxy} from './../../zviz2/zviz/functions';
import filterModel from './../../model/filter';
import PanelBlueprint from './../elements/panel';

import noUiSlider from './../../zviz2/vendor/nouislider';
import {styleFilterHeader, styleText} from './../../styles';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);


        this.options = [];
        this.elementSet = false;
        this.dataLoaded = false;
        this.sliderInitialized = false;
        this.repeatFormatLoop = 0;
        this.curYear = (new Date()).getFullYear();


    }


    setRenderOutput(output){
        super.setRenderOutput(output);
        this.elementSet = true;
        this.setupSlider();
        this.loadData();
    }

    render(renderer){
        super.render(renderer);
        this.formatSlider();
    }

    loadData(){

        // todo: do something on status failed and loading..?
        if(this.models['filter'].status == 'success'){
            let options = [];
            let data = this.models['filter'].data['year'] || [];
            for(var x = 0; x < data.length; x++){
                let val = parseInt(data[x].v, 10); 
                if(val && ! isNaN(val)){
                    options.push(val);
                }
            }
            if(options.length == 0){
                let fil = state.get('filter.year');
                if(fil && fil instanceof Array){
                    options = fil;
                }else{
                    options = [this.curYear - 1, this.curYear];
                }
            }

            let newOptions = false;
            if(options.length == this.options.length){
                for(let o1 of options){
                    let found = false;
                    for(let o2 of this.options){
                        if(o2 == o1){
                            found = true;
                            break;
                        }
                    }
                    if(! found){
                        newOptions = true;
                        break;
                    }
                }
            }else{
                newOptions = true;
            }
            this.options = options;
            this.dataLoaded = true;

            this.setupSlider(newOptions);
        }
    }

    setupSlider(newOptions=true){

        if(newOptions !== true){
            newOptions = false;
        }

        if(! this.dataLoaded || ! this.elementSet){
            return;
        }

        if(! this.renderOutput || ! this.renderOutput.result){
            return;
        }

        let element = this.renderOutput.result;
        let activeYears = state.get('filter.year');
        if(! (activeYears instanceof Array)){
            activeYears = [activeYears];
        }
        if(activeYears.length > 1){
            activeYears.sort();
            activeYears = [ activeYears[0], activeYears[activeYears.length-1] ];
        }
        let o = [];
        for(let y of activeYears){
            if(this.options.indexOf(y) != -1){
                o.push(y);
            }else{
                let v = null;
                let d = 100;
                for(let i of this.options){
                    if(Math.abs(y-i) < d){
                        d = Math.abs(y-i);
                        v = i;
                    }
                }
                if(v != null){
                    o.push(v);
                }
            }
        }
        activeYears = o;

        if(! activeYears || activeYears.length == 0){
            // if(this.options.indexOf(this.curYear) != -1){
            //     activeYears = [this.curYear];
            // }else{
            //     activeYears = [Math.max(...this.options)];
            // }
            if(this.options.length > 0){
                activeYears = [Math.min(...this.options), Math.max(...this.options)];
            }else{
                activeYears = [this.curYear];
            }
        }
        
        if(activeYears.length == 1){
            activeYears.push(activeYears[0]);
        }

        let range = [];
        for(let y = activeYears[0]; y <= activeYears[activeYears.length-1]; y++){
            range.push(y);
        }
        state.set('filter.year', range);

        if(this.sliderInitialized){
            if(newOptions){
                this.renderOutput.result.noUiSlider.off();
                this.renderOutput.result.noUiSlider.destroy();
            }else{
                this.renderOutput.result.noUiSlider.set(activeYears);
                // there could be an animation, so keep checking for a while
                this.formatSlider(100); 
                return;
            }
        }

        
        let min = Math.min( ...this.options );
        let max = Math.max( ...this.options );
        if(min == max){
            min--;
            max++;
        }

        // this is a bit of a trial and error process. Some keys will
        // be minified, others not. 
        // todo? Best would be if all are minified (change source of noUiSlider?)
        noUiSlider.create(element, {
            'start': activeYears,
            'range': {
                'min': min,
                'max': max 
            },
            'step': 1,
            'tooltips': true,
            'format': {to: function(value) { return value; }, 
                    from: function(value){ return value; } 
            },
            pips: {
                mode: 'values',
                values: [min, max],
                density: 100 / (max - min)
            }
        });

        element.noUiSlider.on('change', function(event){
            let start = (event[0])? event[0]: false;
            let stop = (event[1])? event[1]: start;
            if(start){
                let range = [];
                for(let y = start; y <= stop; y++){
                    range.push(y);
                }
                state.set('filter.year', range);
            }
        });

        element.noUiSlider.on('slide', proxy([this, this.formatSlider, 4]));

        this.sliderInitialized = true;
        this.formatSlider(10);
    }

    formatSlider(repeat=false){

        if(repeat){
            this.repeatFormatLoop = repeat;
        }
        if(! this.renderOutput.result){
            return;
        }
        let elms = this.renderOutput.result.getElementsByClassName('noUi-origin');
        let left = 0;
        let width = 0;
        if(elms.length == 2){
            left = elms[0].offsetLeft;
            width = elms[1].offsetLeft - left;
        }
        let elm = document.getElementById('sliderActiveBar' +this.uid);
        if(! elm){
            elm = document.createElement('div');
            elm.setAttribute('id', 'sliderActiveBar' +this.uid);
            elm.setAttribute('class', 'sliderActiveBar');
            this.renderOutput.result.insertBefore(elm, this.renderOutput.result.childNodes[0]);
        }

        elm.style.left = Math.round(left) + 'px';
        elm.style.width = Math.round(width) + 'px';

        // if(this.sliderInitialized){
        //     elm = document.getElementById('sliderTooltip'+this.uid);
        //     if(! elm){
        //         elm = document.createElement('div');
        //         elm.setAttribute('id', 'sliderTooltip'+this.uid);
        //         elm.setAttribute('class', 'sliderTooltip');
        //         this.renderOutput.result.appendChild(elm);
        //     }
        //     if(width < 80){
        //         left -= 0.5* (80-width);
        //         width = 80;
        //     }
        //     if(left < -15){
        //         left = -15;
        //     }else if(left+width+15 > this.renderOutput.result.clientWidth){
        //         left -= (left+width) - this.renderOutput.result.clientWidth;
        //     }
            
        //     let activeYears = this.renderOutput.result.noUiSlider.get();
        //     if(! (activeYears instanceof Array)){
        //         activeYears = [activeYears];
        //     }
        //     let text = activeYears[0];
        //     if(activeYears.length > 1 && activeYears[0] != activeYears[1]){
        //         text += ' - ' + activeYears[1];
        //     }
        //     elm.innerHTML = text;
        //     elm.style.left = Math.round(left-15)+'px';
        //     elm.style.width = Math.round(width+30)+'px';
        // }

        this.repeatFormatLoop--;
        if(this.repeatFormatLoop > 0){
            this.update();
        }
    }

    remove(renderer, removeFromParent=true){
        if(this.sliderInitialized && this.renderOutput && this.renderOutput.result){
            this.renderOutput.result.noUiSlider.off();
            this.renderOutput.result.noUiSlider.destroy();
            this.sliderInitialized = false;
            this.elementSet = false;
            this.dataLoaded = false;
        }
        super.remove(renderer, removeFromParent);
    }

    getClassName(){
        let nc = this.data.className;
        if(this.renderOutput && this.renderOutput.result){
            let oc = this.renderOutput.result.getAttribute('class');
            if(oc){
                let p = oc.split(' ');
                for(let i = 0; i < p.length; i++){
                    if(p[i].substring(0, 4) == 'noUi'){
                        nc += ' ' + p[i];
                    }
                }
            }
        }
        return nc;
    }

}



let Blueprint = extend({
    properties: {
        data: {
            title: 'Date',
            className: 'timeSlider'
        },
        style: {
            'overflow': 'hidden',
        }
    },
    private: {
        children: [
            extend({
                properties:{
                    style: extend({
                        fontSize: '10pt'
                    }, styleText),
                    content: 'Select a range of years for the data'
                }
            }, Group),

            {
                type: Controller,
                models: {
                    'filter': null
                },
                listeners: [
                    (ctrl) => ( ctrl.addListener(ctrl.models['filter'], [ctrl, ctrl.loadData]) ),
                    (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.setupSlider], 'filter.year') )
                ],
                properties: {
                    style: { 
                        position: 'relative', 
                        overflow: 'visible',
                        width: '100%' },
                    attributes: { 
                        'class': (ctrl) => (ctrl.getClassName()) 
                    },
                    data: {
                        className: (ctrl) => (ctrl.parent.parent.data.className),
                    }
                },
                events: {  },
                children: [  ]
            } 
        ]
    }
}, PanelBlueprint);

export default Blueprint;
export {Controller, Blueprint};
